import {createSlice} from "@reduxjs/toolkit";

const initState = {
    installationSelect: {
        label: "",
        value: null,
        activeTab: "",
    },
    reloadTableView: false,
    show2FAModal: false,
}

export const globalDataSlice = createSlice({
    name: "globalData",
    initialState: initState,
    reducers: {
        setInstallationSelect: (state, action) => {
            state.installationSelect = action.payload
        },
        reloadTableView: (state) => {
            state.reloadTableView = true
        },
        reloadedTableView: (state) => {
            state.reloadTableView = false
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        set2FAModalState: (state, action) => {
            state.show2FAModal = action.payload
        },
        clearGlobalState: () => initState
    }

})


export const {
    setInstallationSelect,
    clearGlobalState,
    reloadTableView,
    reloadedTableView,
    setActiveTab,
    set2FAModalState
} = globalDataSlice.actions;
export default globalDataSlice.reducer;